<template>
    <div>
    <vs-dropdown style="float: right; cursor: pointer;" vs-custom-content vs-trigger-click>
      <vs-button color="primary" type="border" icon-pack="feather" icon="icon-more-vertical"></vs-button>

      <vs-dropdown-menu>
        <vs-dropdown-item @click="haldleEdit">Edit</vs-dropdown-item>
        <vs-dropdown-item @click="openConfirmPopup">Delete</vs-dropdown-item>
        
      </vs-dropdown-menu>
    </vs-dropdown>
     <vs-popup  title="Delete Project" :active.sync="deletepopupProject">
        <vs-row>
          <span>Want to delete with livetask?</span>
          
        </vs-row>
        <vs-row vs-type="flex" vs-justify="flex-end" class="mt-4">
          <vs-button @click="haldleDelete('true')" color="primary" type="filled" class="mr-2 vs-con-loading__container">Yes</vs-button>
          <vs-button @click="haldleDelete('false')" type="border">No</vs-button>
        </vs-row>
      </vs-popup>
    </div>

</template>

<script>
import { projectDelete } from '@/api/task-project.js'
import { mapActions } from 'vuex'
export default {
  name: 'CellRendererActionsProject',
  data () {
    return {
      deletepopupProject: false
    }
  },
 
  methods: {
    ...mapActions(['SET_DELETE_ID']),
    openConfirmPopup () {
      this.deletepopupProject = true
    },
    async haldleDelete (liveTaskData) {
      const payload = {
        withLiveTask: liveTaskData
      }
      try {
        const data = await projectDelete(localStorage.getItem('customer_id'), this.params.data.id, payload)
        this.SET_DELETE_ID(this.params.data.id)
        this.deletepopupProject = false
        this.$vs.notify({
          title: 'Project Deleted',
          text: 'Project Deleted Successfully',
          ...this.successProp()
        })
      } catch (error) {
        console.error(error)
        this.deletepopupProject = false
        this.$vs.notify({
          title: 'Warning',
          text: error.data.message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })

      }
      
     
    },
    haldleEdit () {
      this.$router
        .push({
          name: 'tasks-project',
          params: { projectId: this.params.data.id, project: true}
        })
        .catch(() => {})
      
    }
  }
}


</script>